import { getYesOrNo } from "../projectConfiguration";

export const apiField = 'domestic_content'

const config = {
    label: 'isDomesticContent',
    type: 'Select',
    apiField,
    missing: undefined,
    data: getYesOrNo(),
    id: 'isDomesticContent',
    labelClassName: 'label-height-16',
};

export default config;
